import { render, staticRenderFns } from "./FxEXchangeRateHistory.vue?vue&type=template&id=25858aa0&scoped=true"
import script from "./FxEXchangeRateHistory.vue?vue&type=script&lang=js"
export * from "./FxEXchangeRateHistory.vue?vue&type=script&lang=js"
import style0 from "./FxEXchangeRateHistory.vue?vue&type=style&index=0&id=25858aa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25858aa0",
  null
  
)

export default component.exports